import { render, staticRenderFns } from "./Captains.vue?vue&type=template&id=0a66f4d0&scoped=true"
import script from "./Captains.vue?vue&type=script&lang=js"
export * from "./Captains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a66f4d0",
  null
  
)

export default component.exports